import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../class-models/ApiResponse';
import { ShiftType } from '../class-models/common';


@Injectable({
  providedIn: 'root'
})
export class AlertsServiceService {
  baseUrl?: string = '';
  constructor(private http: HttpClient) {
    this.baseUrl = environment.BASE_URL;
   }

   acknowledgeAlert(alertNotification): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl + "Alerts/SaveAlertNotification", alertNotification);
  }
  getAlertNotifications(params: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + "Alerts/GetAlertNotification", params);
  } 
  public GetShiftTypes = (unitId:number): Observable<ShiftType[]> => {
    return this.http.get<ShiftType[]>(this.baseUrl + "Common/GetShiftTypes?unitId=" + unitId);
  }
  GetCurrentShiftDetails(unitId: number): Observable<ShiftType[]> {   
    return this.http.get<ShiftType[]>(this.baseUrl + "Common/GetCurrentShift?unitId=" + unitId);
  }
 
}
